import React from 'react';
import { I18nextProvider as ReactI18nextProvider } from 'react-i18next';
import i18n from './index';

interface I18nextProviderProps {
  children: React.ReactNode;
}

const I18nextProvider: React.FC<I18nextProviderProps> = ({ children }) => {
  return (
    <ReactI18nextProvider i18n={i18n}>
      {children}
    </ReactI18nextProvider>
  );
};

export default I18nextProvider;
